module.exports = {
  google_keyword (keywords, options) {
    return require('./types/google-keyword')(keywords, options)
  },

  url (urls, options) {
    return require('./types/url')(urls, options)
  },

  website_domain (domains, options) {
    return require('./types/website-domain')(domains, options)
  }
}